import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { adornmentType } from 'components/_basic/Form/TextInput/TextInput/types';
import { adornmentIconMap } from 'components/BusinessToolForm/components/VolumeInputField/constants';
import { IProductVolumeInputFieldProps } from 'components/BusinessToolForm/components/VolumeInputField/types';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { concatWithDot } from 'helpers/string';

export const SalesVolumeInputField: FC<IProductVolumeInputFieldProps> = ({ name, disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const volumeInType = useWatch({ name: concatWithDot(name, PRODUCT_NAMES.VOLUME_UNITS) });

  const fieldName = concatWithDot(name, PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL);
  return (
    <NumberInputControlled
      control={control}
      id={fieldName}
      name={fieldName}
      disabled={disabled}
      adornmentType={volumeInType}
      label={t('global.products.monthlySalesPlan', { units: t('physical') })}
      endAdornmentIcon={adornmentIconMap[volumeInType as adornmentType]}
      data-mirror-field={concatWithDot(name, PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL + '.5_1_5')}
    />
  );
};
